import type { ScenarioModel } from '@/shared/generated'
import type { EnrichedScenario, OptimizationGroupMap } from '../model/types'

import { map, pipe, sortBy } from 'lodash/fp'

/**
 * Enriches scenarios with optimization group names and sorts them alphabetically.
 * @param optimizationGroupMap - Map containing group names indexed by their IDs. [OptimizationGroupMap]
 * @param data - Array of raw scenarios to be processed. [ScenarioModel[]]
 * @returns Array of enriched scenarios, sorted by optimization group name (case-insensitive). [EnrichedScenario[]]
 */

export const enrichScenarios =
	(optimizationGroupMap: OptimizationGroupMap | undefined) =>
	(data: ScenarioModel[]) =>
		pipe(
			map((scenario: ScenarioModel) => ({
				...scenario,
				optimization_group_name:
					optimizationGroupMap?.[scenario.optimization_group_id]?.name ||
					scenario.optimization_group_id,
			})),
			sortBy([(option) => option.optimization_group_name.toLowerCase()])
		)(data) as EnrichedScenario[]
